import type { Selector } from 'reselect';
import { createSelector } from 'reselect';

import type { IIndexedMultiAccounts, IMultiAccount, IMultiAccountsState } from './types';

const createAppSelector = createSelector.withTypes<IMultiAccountsState>();

export const selectMultiAccounts = (state: IMultiAccountsState) => state.multiAccounts;

export const selectIndexedMultiAccounts: Selector<IMultiAccountsState, IIndexedMultiAccounts> =
  createAppSelector(selectMultiAccounts, (multiAccounts) =>
    multiAccounts.reduce((indexed: IIndexedMultiAccounts, multiAccount: IMultiAccount) => {
      if (multiAccount.accountDescription) {
        indexed[multiAccount.accountDescription] = multiAccount;
      }
      return indexed;
    }, {}),
  );

export const selectMultiAccount: Selector<IMultiAccountsState, IMultiAccount> = createAppSelector(
  [
    selectIndexedMultiAccounts,
    (_: IMultiAccountsState, accountDescription: string) => accountDescription,
  ],
  (indexedMultiAccounts, accountDescription) => indexedMultiAccounts[accountDescription],
);
